module.exports = __webpack_public_path__ + "static/img/pros-2.1955ec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pros-2.png
// module id = adkg
// module chunks = 1